// Source: https://github.com/ipatate/react-router-scroll-memory/blob/master/src/ScrollMemory.js
// Modified it to allow scrollToElement to take a element selector instead

import { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { isBrowser, getScrollPage, getScrollElement, scrollTo, scrollToElement } from "./utils/utils";

type ScrollProps = {
    location: Object;
    elementSelector?: string;
} & RouteComponentProps<any>;

class ScrollMemory extends Component<ScrollProps> {
    // detectPop: () => void;
    url: Map<string, number>;

    constructor(props: ScrollProps) {
        super(props);
        // add event for click on previous or next browser button
        this.detectPop = this.detectPop.bind(this);
        // stock location key with scroll associate
        this.url = new Map();
    }

    componentDidMount(): void {
        window.addEventListener("popstate", this.detectPop);
    }

    componentWillUnmount(): void {
        window.removeEventListener("popstate", this.detectPop);
    }

    shouldComponentUpdate(nextProps: ScrollProps): boolean {
        if (!isBrowser()) return false;

        const { location } = this.props;
        // location before change url
        const actual = location;
        // location after change url
        const next = nextProps.location;
        // the first page has not key, set "enter" for key
        const key = actual.key || "enter";

        // if hash => let the normal operation of the browser
        const locationChanged =
            (next.pathname !== actual.pathname || next.search !== actual.search) && next.hash === "";

        // get scroll of the page or the element before change location
        const scroll = this.props.elementSelector ? getScrollElement(this.props.elementSelector) : getScrollPage();

        if (locationChanged) {
            // pass page or element scroll to top
            this.props.elementSelector ? scrollToElement(0, document.querySelector(this.props.elementSelector)) : scrollTo(0);
            // save scroll with key location
            this.url.set(key, scroll);
        }
        // never render
        return false;
    }

    /**
     * callback for event popstate
     *
     * @memberof ScrollMemory
     */
    detectPop(location: PopStateEvent): void {
        if (!isBrowser()) return;

        const { state } = location;
        // key or enter page
        const key = state && state.key ? state.key : "enter";
        // get the next for scroll position
        const nextFind = this.url.get(key);

        // if find in url map => scroll to position
        if (nextFind) {
            this.props.elementSelector ? scrollToElement(nextFind, document.querySelector(this.props.elementSelector)) : scrollTo(nextFind);
        }
    }

    render() {
        return null;
    }
}

export default withRouter(ScrollMemory);
